mutation AcceptAiEmailTemplate($input: AiEmailTemplateAcceptInput!) {
    aiEmailTemplateAccept(input: $input) {
        edition {
            htmlUrlPath
        }
    }
}
